import React, { FC } from 'react';
import { Image } from 'react-native';

import { Theme } from '@constants';

import { ALERTS_ANIMATED_ICON_MAP } from '../../../assets/icons/alertsAnimated/alerts_animated_icon_map';
import { ALERTS_ANIMATED_ICON_PATH_MAP } from '../../../assets/icons/alertsAnimated/alerts_animated_icon_path_map';

export const TWCAnimatedAlertIcon: FC<TWCAnimatedAlertIconProps> = ({ eventDescription, height = 48, width = 48 }) => {
  const gif = ALERTS_ANIMATED_ICON_PATH_MAP[ALERTS_ANIMATED_ICON_MAP[eventDescription]];

  return <Image source={gif} style={{ height: Theme.px(height), width: Theme.px(width) }} />;
};

type TWCAnimatedAlertIconProps = {
  eventDescription: keyof typeof ALERTS_ANIMATED_ICON_MAP;
  height?: number;
  width?: number;
};
